<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>接收人配置</span>
        </div>
        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(v,i) in formData" :key="i">
            <el-form-item label="手机号/邮箱">
              <el-input v-model="formData[i]" style="width: 150px;" placeholder="手机号/邮箱" />
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="del(i,1)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-button type="primary" @click="add()">+</el-button>
          <el-button type="primary" @click="onSubmit(1)">保存</el-button>
        </el-form>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { isNumeric } from 'echarts/lib/util/number'

export default {
  name: 'DailySet',
  data() {
    return {
      key: 'dailyConfig',
      total: 0,
      options: [],
      rewardType: [],
      formData: [],
      formData2: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit(type = 1) {
      // if (this.formData.length < 1) {
      //   this.msgError('没有需要提交的数据')
      //   return
      // }
      const chinaPattern = /^1[3-9]\d{9}$/
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      for (const i in this.formData) {
        const val = this.formData[i]
        if (isNumeric(val)) {
          if (!chinaPattern.test(val)) {
            this.msgError('手机号码格式有误')
            return
          }
        } else {
          if (!emailRegex.test(val)) {
            this.msgError('邮箱格式有误')
            return
          }
        }
      }

      updateCommonCfg({ name: this.key, data: JSON.stringify(this.formData) }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.formData = res.data
      })
    },
    add() {
      this.formData.push(0)
    },
    del(index, type = 1) {
      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
